module.exports = Symbol.toPrimitive
